import React, { useEffect, useRef, useState } from "react";

const AUTOPLAY_MS = 5000;

export const Gallery = (props) => {
  const items = props.data || [];
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const timerRef = useRef(null);

  const go = (i) => {
    if (!items.length) return;
    const next = (i + items.length) % items.length;
    setIndex(next);
  };
  const next = () => go(index + 1);
  const prev = () => go(index - 1);

  useEffect(() => {
    if (paused || items.length < 2) return;
    timerRef.current = setTimeout(() => {
      setIndex((i) => (i + 1) % items.length);
    }, AUTOPLAY_MS);
    return () => clearTimeout(timerRef.current);
  }, [index, paused, items.length]);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "ArrowLeft") prev();
      else if (e.key === "ArrowRight") next();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  });

  const current = items[index];

  const renderSlideImage = (d) => {
    const img = (
      <img
        src={d.largeImage || d.smallImage}
        alt={d.title}
        className="gallery-img"
        loading="lazy"
      />
    );
    return d.url ? (
      <a
        href={d.url}
        target="_blank"
        rel="noopener noreferrer"
        className="gallery-link"
        aria-label={`Open ${d.title} in new tab`}
      >
        {img}
      </a>
    ) : (
      img
    );
  };

  return (
    <div id="portfolio" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Products</h2>
          <p>
            Our platforms and enterprise applications — covering gateways, agents, content, and vertical industry scenarios.
          </p>
        </div>

        {items.length > 0 && (
          <div
            className="gallery-carousel"
            onMouseEnter={() => setPaused(true)}
            onMouseLeave={() => setPaused(false)}
          >
            <div className="gallery-stage">
              {items.map((d, i) => (
                <div
                  key={`${d.title}-${i}`}
                  className={`gallery-slide ${i === index ? "is-active" : ""}`}
                  aria-hidden={i === index ? "false" : "true"}
                >
                  {renderSlideImage(d)}
                </div>
              ))}

              <button
                type="button"
                className="gallery-nav gallery-prev"
                onClick={prev}
                aria-label="Previous slide"
              >
                <i className="fa fa-chevron-left" />
              </button>
              <button
                type="button"
                className="gallery-nav gallery-next"
                onClick={next}
                aria-label="Next slide"
              >
                <i className="fa fa-chevron-right" />
              </button>
            </div>

            <div className="gallery-caption">
              {current ? (
                current.url ? (
                  <a
                    href={current.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="gallery-caption-link"
                  >
                    {current.title}
                  </a>
                ) : (
                  current.title
                )
              ) : (
                ""
              )}
            </div>

            <div className="gallery-dots" role="tablist">
              {items.map((_, i) => (
                <button
                  key={i}
                  type="button"
                  className={`gallery-dot ${i === index ? "is-active" : ""}`}
                  onClick={() => go(i)}
                  aria-label={`Go to slide ${i + 1}`}
                  aria-selected={i === index}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
